<template>
  <v-container class="bottom">
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11 xl10>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 offset-xl0 md9 lg10 xs12 sm11 xl10>
        <v-layout>
          <v-flex md12 lg12 xs12 sm12>
            <h4 class="pull">Desarrollo de proyectos operativos 2020.</h4>
            <p
              class="pull"
            >En función de las estrategias priorizadas para el año 2020 - 2021 (Planes de Desarrollo) y las respectivas iniciativas propuestas por la Unidad, deberá desarrollar un conjunto de actividades orientadas a su operativización.</p>
          </v-flex>
        </v-layout>
        <v-flex v-if="vacio" class="containerBanner" md12 lg12 xs12 sm12>
          <img :src="nube" style="width:25%;" />
        </v-flex>
        

        <v-flex v-if="vacio" md12 lg12 xs12 sm12>
          <h4>No existen estratégias para el año {{this.$route.params.id}}</h4>
          <h4>Crea una nueva estratégias</h4>
        </v-flex>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="!vacio">
          <v-layout>
            <v-flex md6 lg6 xs6 sm6>
              <label class="left" for="sel1">Ejes Estratégicos</label>
              <select class="form-control" id="5" @change="cargarPoliticas()" v-model="eje">
                <option selected disabled>-Selecciona una opción-</option>
                <option value="1">Desarrollo territorial</option>
                <option value="2">Desarrollo tecnológico, innovación y emprendimiento</option>
                <option value="3">Inclusión e igualdad de género</option>
                <option value="4">Sostenibilidad</option>
                <option value="5">Internacionalización e interculturalidad</option>
              </select>
            </v-flex>
            <v-flex md6 lg6 xs6 sm6>
              <v-btn
                id="boton"
                small
                href="#demo"
                data-toggle="collapse"
                color="#EB7704"
                @click="proyectoEje =! proyectoEje"
              >info proyecto</v-btn>
              <v-btn
                small
                id="boton"
                color="#394049"
                v-if="!vacio && this.$session.getAll().userType == 'dge'"
                @click="descargarProyectos()"
              >
                <v-icon dark>cloud_download</v-icon>
              </v-btn>
              <v-btn
                id="boton"
                small
                color="#394049"
                v-if="proyectoEje"
                @click="editEje =! editEje"
              >
                <v-icon dark>edit</v-icon>
              </v-btn>
              <v-btn
                v-if="proyectoEje"
                id="boton"
                small
                color="#EB7704"
                :disabled="editEje"
                @click="editarEje()"
              >
                <v-icon dark>save</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <!-- <v-layout>
            <v-flex md10 lg10 xs10 sm10>
              <label class="left" for="sel1">Estrategias</label>
              <select class="form-control" id="5" @change="cargarProyecto()" v-model="politica">
                <option selected disabled>-Selecciona una opción-</option>
                <option
                  v-for="(politica,index) in politicas"
                  :key="index"
                  :value="politica"
                >{{politica.nombrePolitica}}</option>
              </select>
            </v-flex>
            <v-flex md2 lg2 xs2 sm2>
              <v-btn
                id="boton"
                color="#394049"
                v-if="!vacio && this.$session.getAll().userType == 'dge'"
                @click="descargarProyectos()"
              >
                <v-icon dark>cloud_download</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>-->

          <v-layout>
            <v-flex md12 lg12 xs12 sm12 xl12>
              <div id="demo" class="collapse">
                <table class="table table-striped header-fixed table-bordered">
                  <thead>
                    <tr>
                      <th
                        style="text-align: left"
                        class="col-md-2 col-xs-2 col-lg-2 col-sm-2"
                      >Objetivo del Proyecto</th>
                      <th style="text-align: left" class="col-md-10 col-xs-10 col-lg-10 col-sm-10">
                        <input
                          :disabled="editEje"
                          class="form-control"
                          rows="3"
                          v-model="ejedata.objetivoEstrategico"
                        />
                      </th>
                    </tr>

                    <tr>
                      <th
                        style="text-align: left"
                        class="col-md-2 col-xs-2 col-lg-2 col-sm-2"
                      >Encargado</th>
                      <th style="text-align: left" class="col-md-10 col-xs-10 col-lg-10 col-sm-10">
                        <input
                          :disabled="editEje"
                          class="form-control"
                          rows="3"
                          v-model="ejedata.encargado"
                        />
                      </th>
                    </tr>
                    <tr>
                      <th style="text-align: left" class="col-md-2 col-xs-2 col-lg-2 col-sm-2">Email</th>
                      <th style="text-align: left" class="col-md-4 col-xs-4 col-lg-4 col-sm-4">
                        <input
                          :disabled="editEje"
                          class="form-control"
                          rows="3"
                          v-model="ejedata.correoEncargado"
                        />
                      </th>
                      <th style="text-align: left" class="col-md-2 col-xs-2 col-lg-2 col-sm-2">Anexo</th>
                      <th style="text-align: left" class="col-md-4 col-xs-4 col-lg-4 col-sm-4">
                        <input
                          :disabled="editEje"
                          class="form-control"
                          rows="3"
                          v-model="ejedata.anexoEncargado"
                        />
                      </th>
                    </tr>

                    <tr>
                      <th
                        style="text-align: left"
                        class="col-md-2 col-xs-2 col-lg-2 col-sm-2"
                      >Resumen</th>
                      <th style="text-align: left" class="col-md-10 col-xs-10 col-lg-10 col-sm-10">
                        <textarea
                          class="form-control"
                          :disabled="editEje"
                          rows="6"
                          v-model="ejedata.resumen"
                        ></textarea>
                      </th>
                    </tr>

                    <tr>
                      <th
                        style="text-align: left"
                        class="col-md-2 col-xs-2 col-lg-2 col-sm-2"
                      >Impacto</th>
                      <th style="text-align: left" class="col-md-10 col-xs-10 col-lg-10 col-sm-10">
                        <textarea
                          :disabled="editEje"
                          class="form-control"
                          rows="3"
                          v-model="ejedata.impacto"
                        ></textarea>
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md12 lg12 xs12 sm12 xl12>
              <table class="table table-striped header-fixed">
                <thead>
                  <tr>
                    <th
                      style="text-align: left"
                      class="col-md-2 col-xs-2 col-lg-2 col-sm-2 th-border"
                    >Presupuesto de Eje</th>
                    <th
                      style="text-align: left"
                      class="col-md-4 col-xs-4 col-lg-4 col-sm-4 th-border"
                    >{{formatPrice(monto)}}</th>
                    <th
                      style="text-align: left"
                      class="col-md-2 col-xs-2 col-lg-2 col-sm-2 th-border"
                    >Presupuesto Total</th>
                    <th
                      style="text-align: left"
                      class="col-md-4 col-xs-4 col-lg-4 col-sm-4 th-border"
                    >{{formatPrice(montoGral)}}</th>
                  </tr>
                  <tr>
                    <th
                      style="text-align: left"
                      class="col-md-2 col-xs-2 col-lg-2 col-sm-2 th-border"
                    >Estrategia</th>
                    <th
                      style="text-align: left"
                      class="col-md-10 col-xs-10 col-lg-10 col-sm-10 th-border"
                    >
                      <select
                        class="form-control"
                        id="5"
                        @change="cargarProyecto()"
                        v-model="politica"
                      >
                        <option selected disabled>-Selecciona una opción-</option>
                        <option
                          v-for="(politica,index) in politicas"
                          :key="index"
                          :value="politica"
                        >{{politica.nombrePolitica}}</option>
                      </select>
                    </th>
                  </tr>

                  <tr>
                    <th
                      style="text-align: center"
                      :class="header.border"
                      v-for="(header,index) in headers"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in hitos" :key="index">
                    <td style="text-align:left " :class="headers[0].size">{{item.nombreEstrategia}}</td>
                    <td style="text-align:left " :class="headers[1].size">{{item.actividades}}</td>
                    <!-- esto formatea fechas-->

                    <td style="text-align:center " :class="headers[2].size">{{item.fuente}}</td>
                    <td
                      style="text-align:center "
                      :class="headers[3].size"
                    >{{formatPrice(item.monto)}}</td>
                    <td style="text-align:center " :class="headers[4].size">{{item.estadoAvance}}</td>
                    <td style="text-align:center " :class="headers[5].size">{{item.evaluacion}}</td>
                    <td :class="headers[6].size">
                      <v-icon
                        v-if="permiso && ano == 2018"
                        small
                        class="mr-2"
                        @click="openEditObservaciones(item,index)"
                      >edit</v-icon>
                      <v-icon v-if="permiso" small @click="openEditObservaciones(item,index)">edit</v-icon>
                      <v-icon v-if="permiso" small @click="deleteEstrategia(item)">delete</v-icon>

                      <v-tooltip v-if="$route.params.id=='2020'"  bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon small color="#2c3e50" dark v-on="on">info</v-icon>
                        </template>
                        <span>Linea de trabajo: {{item.linea}}</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout>
      <!--<v-btn v-if="permiso" color="#394049" @click="openEditProyecto()">Editar politica</v-btn>
      <v-btn color="#394049" @click="opencreateProyecto()">Agregar política</v-btn>-->
      <v-btn color="#394049" v-if="!vacio && permiso" @click="opencreateHito">Agregar iniciativa</v-btn>
      <v-btn
        color="#394049"
        v-if="!vacio"
        :to="{name:'documentosEstrategia',params: { id: this.$route.params.id, idEje:this.politica.id }}"
      >Ver evidencias</v-btn>
      <v-btn color="#394049" v-if="!vacio" @click="descargarEvaluacion()">Descargar Evaluación</v-btn>
      <v-btn color="#EB7704" v-if=" !vacio" @click="preguntas = !preguntas">Evaluación Anual</v-btn>
      <v-btn
        v-if="this.$session.getAll().permiso && this.$session.getAll().userType=='dge'"
        color="#EB7704"
        @click="descargarIniciativasDGE()"
      >Descargar Información</v-btn>
    </v-layout>

    <v-layout>
      <v-dialog v-model="edit" width="600px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline" v-if="!create">Editar iniciativa</span>
            <span class="headline" v-if="create">Crear iniciativa</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Estrategias asociada</label>
                <input
                  :disabled="true"
                  v-model="politica.nombrePolitica"
                  type="text"
                  class="form-control"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Iniciativa</label>
                <input
                  v-model="estrategia.nombreEstrategia"
                  placeholder="Ingrese el nombre de la Iniciativa"
                  type="text"
                  class="form-control"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Actividades</label>
                <textarea
                  :disabled="!permiso"
                  v-model="estrategia.actividades"
                  placeholder="Ingrese las Actividades"
                  type="text"
                  class="form-control"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Presupuesto</label>
                <input
                  :disabled="!permiso"
                  v-model="estrategia.monto"
                  type="number"
                  min="0"
                  placeholder="Ingrese el Presupuesto (solo dígitos)"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  class="form-control"
                />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Item de gasto</label>
                <select
                  class="form-control"
                  id="5"
                  :disabled="!permiso"
                  v-model="estrategia.fuente"
                >
                  <option selected disabled>-Selecciona una opción-</option>
                  <option value="Honorarios">Honorarios</option>
                  <option value="Becas a estudiantes ayudantes">Becas a estudiantes ayudantes</option>
                  <option value="Compra de equipos y bienes">Compra de equipos y bienes</option>
                  <option value="Insumos relacionados">Insumos relacionados</option>
                  <option value="Mobiliarios">Mobiliarios</option>
                  <option
                    value="Estadías de académicos y profesionales"
                  >Estadías de académicos y profesionales</option>
                  <option value="Becas de movilidad estudiantil">Becas de movilidad estudiantil</option>
                  <option
                    value="Montaje de ferias y exposiciones, arriendo de equipos"
                  >Montaje de ferias y exposiciones, arriendo de equipos</option>
                  <option value="Otros">Otros</option>
                </select>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label>Estado de avance</label>
                <select class="form-control" id="5" v-model="estrategia.estadoAvance">
                  <option selected disabled>-Selecciona una opción-</option>
                  <option value="No iniciado">No iniciado</option>
                  <option value="En desarrollo">En desarrollo</option>
                  <option value="Finalizado">Finalizado</option>
                </select>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label>Evaluación</label>
                <select class="form-control" id="5" v-model="estrategia.evaluacion">
                  <option selected disabled>-Selecciona una opción-</option>
                  <option
                    value="Los resultados esperados se cumplen en forma insuficiente"
                  >Los resultados esperados se cumplen en forma insuficiente</option>
                  <option
                    value="Los resultados esperados cumplen en forma satisfactoria"
                  >Los resultados esperados cumplen en forma satisfactoria</option>
                  <option
                    value="Los resultados superan satisfactoriamente lo esperado"
                  >Los resultados superan satisfactoriamente lo esperado</option>
                </select>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="edit = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="!create" @click="editEstrategia()">Guardar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="create" @click="createEstrategia()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout>
      <v-dialog v-model="project" width="600px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">Crear Proyecto</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Nombre de Proyecto</label>
                <input v-model="proyectoNuevo.nombreProyecto" type="text" class="form-control" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Año de Proyecto</label>
                <input
                  :disabled="true"
                  v-model="proyectoNuevo.ano"
                  type="text"
                  class="form-control"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Objetivo Estratégico</label>
                <input v-model="proyectoNuevo.objetivoEstrategico" type="text" class="form-control" />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="project = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="createProyecto()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout>
      <v-dialog v-model="projectEdit" width="600px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">Editar Proyecto</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Nombre de Proyecto</label>
                <input v-model="politica.nombreProyecto" type="text" class="form-control" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Año de Proyecto</label>
                <input :disabled="true" v-model="politica.ano" type="text" class="form-control" />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Objetivo Estratégico</label>
                <input v-model="politica.objetivoEstrategico" type="text" class="form-control" />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="rgb(236, 18, 40)" flat="flat" @click="deleteProyecto(politica)">Eliminar</v-btn>
            <v-btn color="#ec6a12" flat="flat" @click="projectEdit = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="editProyecto()">Actualizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout>
      <v-dialog v-model="preguntas" width="600px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">Evaluación Anual</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label
                  for="usr"
                >¿Cuáles son los principales aportes de la estrategia al desarrollo estratégico de su unidad?</label>
                <textarea v-model="politica.pregunta1" type="text" class="form-control" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label
                  for="usr"
                >¿Cuáles son los avances obtenidos respecto al objetivo estratégico asociado a la estrategia?</label>
                <textarea v-model="politica.pregunta2" type="text" class="form-control" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label
                  for="usr"
                >¿Qué elementos de su estrategia, considera necesario que se pueda replicar a nivel institucional?</label>
                <textarea v-model="politica.pregunta3" type="text" class="form-control" />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="preguntas = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="addPreguntas()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- <v-layout>
      <v-dialog v-model="proyectoEje" width="600px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">Editar datos de proyecto</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Objetivo Estratégico</label>
                <input v-model="politica.pregunta1" type="text" class="form-control" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Nombre del encargado</label>
                <input v-model="politica.pregunta1" type="text" class="form-control" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Email del encargado</label>
                <input v-model="politica.pregunta1" type="text" class="form-control" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Anexo del encargado</label>
                <input v-model="politica.pregunta1" type="text" class="form-control" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Resumen del proyecto</label>
                <textarea v-model="politica.pregunta2" type="text" class="form-control" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Impacto del proyecto</label>
                <textarea v-model="politica.pregunta3" type="text" class="form-control" />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="preguntas = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="addPreguntas()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>-->
  </v-container>
</template>


<script>
import img1 from "../../assets/BANNER_4.png";
import img3 from "../../assets/nuevaasistenciadca.png";
import nube from "../../assets/nube.png";

export default {
  data() {
    return {
      ejedata: "",
      editEje: true,
      proyectoEje: "",
      eje: "",
      monto: "",
      montoGral: "",
      projectEdit: false,
      ano: "",
      permiso: "",
      preguntas: false,
      vacio: false,
      img3: img3,
      politica: [],
      proyectoNuevo: {
        ano: "",
        nombreProyecto: "",
        objetivoEstrategico: ""
      },
      project: false,
      politicas: "",
      nube: nube,
      hitos: "",
      asistencia: false,
      create: false,
      edit: false,
      index: "",
      tipodimension: "",
      dialog: false,
      estrategia: {},
      misionPropuesta:
        "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word, Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word",
      headers: [
        {
          text: "Iniciativa",
          value: "name",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2",
          border: "col-md-2 col-lg-2 col-sm-2 col-xs-2 th-border"
        },
        {
          text: "Actividad",
          value: "name",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2",
          border: "col-md-2 col-lg-2 col-sm-2 col-xs-2 th-border"
        },

        {
          text: "Item de gasto",
          value: "muy desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2",
          border: "col-md-2 col-lg-2 col-sm-2 col-xs-2 th-border"
        },
        {
          text: "Presupuesto",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },

        {
          text: "Avance",
          value: "muy desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2",
          border: "col-md-2 col-lg-2 col-sm-2 col-xs-2 th-border"
        },

        {
          text: "Evaluación",
          value: "muy desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2",
          border: "col-md-2 col-lg-2 col-sm-2 col-xs-2 th-border"
        },
        {
          text: "Editar",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        }
      ],
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      img1: img1,
      right: null
    };
  },

  watch: {
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      this.cargarPoliticas();
    }
  },

  created() {
    //console.log(this.$session.getAll().permiso);
    this.eje = 1;
    this.cargarPoliticas();
  },
  methods: {
    redirect(index) {
      this.typeEstrategico = index;
    },
    updateOtros(propuesta) {
      this.dialog = false;
    },

    cargarProyecto() {
      this.cargarEstrategias();
    },

    forceFileDownload(response, tipo) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        tipo +
          "-centro-costo-" +
          this.$session.getAll().ccData.ccValor +
          ".xlsx"
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    forceFileDownloadGeneral(response, tipo) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", tipo + "- General.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    descargarEvaluacion() {
      axios
        .get(
          process.env.ROOT_API +
            "/politica/exportProyectos?ccValor=" +
            this.$session.getAll().ccData.ccValor +
            "&ano=" +
            this.$route.params.id,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          this.forceFileDownload(response, "Info general politicas");

          //console.log(this.hitos);
        })
        .catch(error => {
          console.error(error);
        });
    },

    descargarProyectos() {
      axios
        .get(
          process.env.ROOT_API +
            "/estrategia/exportHitos?ccValor=" +
            this.$session.getAll().ccData.ccValor +
            "&ano=" +
            this.$route.params.id,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          this.forceFileDownload(response, "Detalle hitos de politicas");

          //console.log(this.hitos);
        })
        .catch(error => {
          console.error(error);
        });
    },

    descargarIniciativasDGE() {
      axios
        .get(
          process.env.ROOT_API +
            "/estrategia/exportAllIniciativas?ano=" +
            this.$route.params.id,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          this.forceFileDownloadGeneral(response, "Detalle Iniciativas ");

          //console.log(this.hitos);
        })
        .catch(error => {
          console.error(error);
        });
    },
    initComponent() {
      this.ano = 1;
      this.permiso = this.$session.getAll().permiso;
      axios
        .get(
          process.env.ROOT_API +
            "/politica/allPoliticasByPeriodo?periodo=" +
            this.ano +
            "&ccValor=" +
            this.$session.getAll().ccData.ccValor,
          this.auth
        )
        .then(response => {
          this.politicas = response.data;
          if (response.data.length == 0) {
            //console.log("ENTRANDO AL VACIOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO");
            this.vacio = true;
            //console.log("Vacio1: " + this.vacio);
          } else {
            this.vacio = false;
            this.politica = this.politicas[0];
            //console.log(this.politicas);
            this.cargarEstrategias();
            //console.log("Vacio2: " + this.vacio);
          }
        })
        .catch(error => {
          console.error(error);
        });
    },

    deleteEstrategia(item) {
      //console.log(item);
      axios
        .delete(
          process.env.ROOT_API +
            "/estrategia/deleteEstrategia?correo=" +
            this.$session.get("email") +
            "&id=" +
            item.id,
          this.auth
        )
        .then(response => {
          alert(response.data);
          this.cargarEstrategias();
        })
        .catch(error => {
          console.error(error);
        });
    },

    cargarEstrategias() {
      axios
        .get(
          process.env.ROOT_API +
            "/estrategia/allEstrategiasByPolitica?idPolitica=" +
            this.politica.id +
            "&ano=" +
            this.$route.params.id,
          this.auth
        )
        .then(response => {
          this.hitos = response.data;
          //console.log(this.hitos);
          this.cargarCuentaMonto();
          this.cargarCuentaMontoGral();
        })
        .catch(error => {
          console.error(error);
        });
    },

    formatPrice(value) {
      if (value != null && value != "") {
        return "$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        return "";
      }
    },

    formatPriceCampo(value) {
      //console.log(value);
      var formatted = "";
      if (value != null && value != "") {
        formatted =
          "$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        formatted = "";
      }
      //console.log(formatted);
      this.estrategia.monto = formatted;
    },

    cargarCuentaMonto() {
      axios
        .get(
          process.env.ROOT_API +
            "/estrategia/getCountMontoByEjeAndCC?ccValor=" +
            this.$session.getAll().ccData.ccValor +
            "&idEje=" +
            this.eje +
            "&periodo=" +
            this.ano +
            "&ano=" +
            this.$route.params.id,
          this.auth
        )
        .then(response => (this.monto = response.data))
        .catch(error => {
          console.error(error);
        });
    },

    cargarCuentaMontoGral() {
      axios
        .get(
          process.env.ROOT_API +
            "/estrategia/getCountMonto?ccValor=" +
            this.$session.getAll().ccData.ccValor +
            "&periodo=" +
            this.ano +
            "&ano=" +
            this.$route.params.id,
          this.auth
        )
        .then(response => (this.montoGral = response.data))
        .catch(error => {
          console.error(error);
        });
    },

    dateFormatted(date) {
      var current_datetime = new Date(date);
      var formatted_date =
        current_datetime.getDate() +
        "-" +
        (current_datetime.getMonth() + 1) +
        "-" +
        current_datetime.getFullYear();
      return formatted_date;
    },

    dateFormattedUSA(date) {
      var current_datetime = new Date(date);
      var formatted_date =
        current_datetime.getMonth() +
        1 +
        "-" +
        current_datetime.getDate() +
        "-" +
        current_datetime.getFullYear();
      return formatted_date;
    },

    openEditObservaciones(estrategia, index) {
      this.create = false;
      this.edit = true;
      this.index = index;
      this.estrategia = estrategia;
    },

    openEditProyecto() {
      this.proyectoNuevo.nombreProyecto = this.politica.nombreProyecto;
      this.proyectoNuevo.objetivoEstrategico = this.politica.objetivoEstrategico;
      this.proyectoNuevo.ano = parseInt(this.$route.params.id);
      this.projectEdit = true;
    },

    deleteProyecto(item) {
      //console.log( item);
      axios
        .delete(
          process.env.ROOT_API + "/politica/delete?idProyecto=" + item.id,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          alert(response.data);
          this.cargarPoliticas();
        })
        .catch(error => {
          //console.log(error);
          alert(error);
        });
      this.projectEdit = false;
    },

    opencreateProyecto(estrategia, index) {
      this.proyectoNuevo.nombreProyecto = "";
      this.proyectoNuevo.objetivoEstrategico = "";
      this.proyectoNuevo.ano = parseInt(this.$route.params.id);
      this.project = true;
    },
    createProyecto() {
      axios
        .post(
          process.env.ROOT_API +
            "/politica/createProyecto?ccValor=" +
            this.$session.getAll().ccData.ccValor,
          this.proyectoNuevo,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          alert("Proyecto creado");
          this.project = false;
          this.vacio = false;
          this.cargarPoliticas();
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
    },

    opencreateHito() {
      this.create = true;
      this.edit = true;
      this.estrategia = {};
    },

    editEstrategia() {
      axios
        .post(
          process.env.ROOT_API + "/estrategia/updateEstrategia",
          this.estrategia,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          alert("Iniciativa actualizada");
          this.edit = false;
          this.cargarEstrategias();
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
    },

    editProyecto() {
      axios
        .post(
          process.env.ROOT_API + "/politica/updateProyecto",
          this.politica,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          alert("Proyecto actualizado");
          this.projectEdit = false;
          this.cargarProyecto();
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
    },

    editarEje() {
      axios
        .post(process.env.ROOT_API + "/eje/updateEje", this.ejedata, this.auth)
        .then(response => {
          //console.log(response.data);
          alert("Eje actualizado");
          this.editEje = !this.editEje;
          this.cargarEje();
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
    },

    cargarEje() {
      //console.log(this.eje);
      axios
        .get(
          process.env.ROOT_API +
            "/eje/getEje?ccValor=" +
            this.$session.getAll().ccData.ccValor +
            "&codigo=" +
            this.eje,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.ejedata = response.data;
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
    },

    cargarPoliticas() {
      this.politica={}
      this.politicas=[]
      this.ano = 1;
      this.permiso = this.$session.getAll().permiso;
      axios
        .get(
          process.env.ROOT_API +
            "/politica/allPoliticasByPeriodo?ccValor=" +
            this.$session.getAll().ccData.ccValor +
            "&idEje=" +
            this.eje +
            "&periodo=" +
            this.ano +
            "&ano=" +
            this.$route.params.id,
          this.auth
        )
        .then(response => {
          this.politicas = response.data;
          //console.log(this.politicas);
          if (response.data.length == 0) {
            //console.log("ENTRANDO AL VACIOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO");
            //this.vacio = true;
            this.hitos = "";
            //console.log("Vacio1: " + this.vacio);
          } else {
            this.vacio = false;
            this.politica = this.politicas[0];
            //console.log(this.politicas);
            this.cargarEstrategias();
            //console.log("Vacio2: " + this.vacio);
          }
        })
        .catch(error => {
          console.error(error);
        });
      this.cargarEje();
    },

    createEstrategia() {
      this.estrategia.semestre = this.$route.params.id;
      axios
        .post(
          process.env.ROOT_API +
            "/estrategia/createEstrategia?idPolitica=" +
            this.politica.id,
          this.estrategia,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          alert("Iniciativa agregada");
          this.edit = false;
          this.cargarEstrategias();
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
    },

    addPreguntas() {
      axios
        .post(
          process.env.ROOT_API + "/politica/addPreguntas",
          this.politica,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          alert("Evaluación anual completada");
          this.preguntas = false;
          this.cargarProyecto();
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
    },

    replaceT(texto) {
      var newTexto = texto.replace(/\n/g, "<br />");
      //console.log(newTexto);
      return newTexto;
    }
  }
};
</script>


<style scoped>
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 100px !important;
}

.v-card-new {
  margin-top: 50px;
  margin-bottom: 3%;
  margin-left: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: 230px !important;
  overflow-y: auto;
}

.v-card {
  height: 350px;
  overflow-y: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 300px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 11px;
  border-bottom: 0 !important;
}

.th-border {
  border: #ddd 1px solid !important;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.bottom {
  margin-bottom: 50px !important;
}

#boton {
  margin-top: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/implementacion/EstrategiasSeguimiento.vue